
import request from '@/utils/request'
var http = process.env.BASE_API;
var big_data = "https://bigdata.q12301.com"
// 获取舆情列表
export function get_subscribe_info_list(query) {
  return new Promise((resolve, reject) => {
    var returnData = request({
      url: big_data + '/big-data/backend/get_new_subcribe_info_list/',
      method: 'get',
      params: query
    })
    if (true) {
      resolve(returnData)
    }
  })
}
// 获取舆情动态
export function get_dynamic_subscribe_info_list(query) {
  return new Promise((resolve, reject) => {
    var returnData = request({
      url: big_data + '/big-data/backend/get_dynamic_subcribe_info_list/',
      method: 'get',
      params: query
    })
    if (true) {
      resolve(returnData)
    }
  })
}
// 获取舆情动态详情
export function get_dynamic_subscribe_info_detail(query) {
  return new Promise((resolve, reject) => {
    var returnData = request({
      url: big_data + '/big-data/backend/get_dynamic_subcribe_info_detail/',
      method: 'get',
      params: query
    })
    if (true) {
      resolve(returnData)
    }
  })
}

// 舆情管理后台获取获取时间趋势
export function get_subscribe_time_trend(query) {
  return new Promise((resolve, reject) => {
    var returnData = request({
      url: big_data + '/big-data/backend/get_subcribe_time_trend/',
      method: 'get',
      params: query
    })
    if (true) {
      resolve(returnData)
    }
  })
}

// 舆情管理后台删除记录
export function delete_dynamic_subcribe_info(data) {
  return new Promise((resolve, reject) => {
    var returnData = request({
      url: big_data + '/big-data/backend/delete_dynamic_subcribe_info/',
      method: 'post',
      data
    })
    if (true) {
      resolve(returnData)
    }
  })
}

// 舆情管理后台更新记录
export function update_dynamic_subcribe_emotion_info(data) {
  return new Promise((resolve, reject) => {
    var returnData = request({
      url: big_data + '/big-data/backend/update_dynamic_subcribe_emotion_info/',
      method: 'post',
      data
    })
    if (true) {
      resolve(returnData)
    }
  })
}




// WEBPACK FOOTER //
// ./src/api/sentiment.js